import { render, staticRenderFns } from "./TiposReceita.vue?vue&type=template&id=4300f2a3&"
import script from "./TiposReceita.vue?vue&type=script&lang=js&"
export * from "./TiposReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports